import React from "react";
import * as motion from "motion/react-client";

interface ZoomImageProps {
  src?: string;
  alt?: string;
  children?: React.ReactNode;
  onClick?: () => void;
}

const ZoomImage: React.FC<ZoomImageProps> = ({
  src,
  alt,
  children,
  onClick,
}) => {
  return src ? (
    <motion.div
      onClick={onClick}
      initial={{ opacity: 0.5 }}
      animate={{ opacity: 1 }}
      className="cursor-pointer w-full bg-gray-200 relative"
      transition={{ duration: 0.3, ease: "easeOut" }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
    >
      <img
        src={src}
        alt={alt ? alt : "image"}
        className="object-cover h-full w-full absolute inset-0"
      />
      {children}
    </motion.div>
  ) : null;
};

export default ZoomImage;
